import { observer } from "mobx-react";
import { EnterpriseAccountsStore } from "./enterpriseAccountsDomain";
import { FC } from "react";
import { Box, Card, VBox } from "../components-v2/Box";
import { useTranslation } from "../stores/RootStoreContext";
import { Dialog } from "../components-v2/Dialog";
import { MTextInput } from "../components-v2/TextInput";
import { Tag } from "../components-v2/Tag";
import { LinkButton } from "../components-v2/Button";

export const SharepointSettingsDialog: FC<{ store: EnterpriseAccountsStore }> = observer(
  ({ store }) => {
    const { t } = useTranslation();
    if (!store.integrationSettingsModel) {
      return null;
    }
    return (
      <Dialog
        title={t("sharepoint.connect-site")}
        onCancel={() => store.toggleSharepointSettingsDialog()}
        onSubmit={() => store.addOrUpdateSharepointSettings()}
        submitLabel={t("sharepoint.connect")}
        submitResult={store.submitSharepointSettingsResult}
      >
        <VBox gap={"lg"}>
          {t("sharepoint.connect-site.help-text")}
          <MTextInput
            model={store.integrationSettingsModel.siteID}
            label={t("sharepoint.siteID")}
          />
          <MTextInput
            model={store.integrationSettingsModel.clientID}
            label={t("sharepoint.clientID")}
          />
          <MTextInput
            model={store.integrationSettingsModel.clientSecret}
            label={t("sharepoint.clientSecret")}
          />
          <MTextInput
            model={store.integrationSettingsModel.tenantID}
            label={t("sharepoint.tenantID")}
          />
        </VBox>
      </Dialog>
    );
  },
);

export const SharepointSettings: FC<{ store: EnterpriseAccountsStore }> = observer(({ store }) => {
  const { t } = useTranslation();
  return (
    <Card padding gap={"lg"} maxWidth={"xl"} grow={"golden"} justifyContent={"center"}>
      <Box justifyContent={"space-between"}>
        <Box gap={"md"}>
          <h5>{t("integrations.sharepoint")}</h5>
          <Tag color={"success"} label={t("integrations.active")} compact />
        </Box>
        <Box>
          <LinkButton
            weight={"normal"}
            size={"sm"}
            icon={"pen"}
            label={t("edit")}
            onClick={() => {
              store.submitSharepointSettingsResult = undefined;
              store.toggleSharepointSettingsDialog();
            }}
          />
        </Box>
      </Box>
    </Card>
  );
});
